/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagDropdownInterest200,
  GetApiV1TagDropdownInterest401,
  GetApiV1TagDropdownInterest500,
  GetApiV1TagDropdownInterestQueryParams,
  GetApiV1TagDropdownInterestQueryResponse,
} from "../../types/tagRegistroController/GetApiV1TagDropdownInterest.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1TagDropdownInterestQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
    ids: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1TagDropdownInterestQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagDropdownInterest200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1TagDropdownInterest200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagDropdownInterest401Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownInterest401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagDropdownInterest500Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownInterest500>;

export const getApiV1TagDropdownInterestQueryResponseSchema = z.lazy(
  () => getApiV1TagDropdownInterest200Schema,
) as unknown as ToZod<GetApiV1TagDropdownInterestQueryResponse>;
